import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "Disciplines",
  ref: "containerRef"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Discipline = _resolveComponent("Discipline")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[0] || (_cache[0] = _createElementVNode("h3", { class: "Title" }, "Suggested Fields of Study", -1 /* CACHED */)),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.topLevelDisciplines, (discipline) => {
      return (_openBlock(), _createBlock(_component_Discipline, { discipline: discipline }, null, 8 /* PROPS */, ["discipline"]))
    }), 256 /* UNKEYED_FRAGMENT */))
  ], 512 /* NEED_PATCH */))
}